import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../../css/HuaweiEventLanding.module.css';

const WHY_ITEMS = [
    {
        image: 'https://resource.ewe.rs/media/HuaweiEvent2026/icon-portfolio.png',
        heading: 'Huawei eKit portfolio na jednom mestu',
        text: 'Switch-evi, access point uređaji, ruteri, Wi-Fi 6 i Wi-Fi 7 rešenja i druga mrežna oprema na jednom mestu.',
    },
    {
        image: 'https://resource.ewe.rs/media/HuaweiEvent2026/icon-partnerstvo.png',
        heading: 'Novi potencijal za partnere',
        text: 'Otkrijte šta novo partnerstvo EWE-a i Huawei-a donosi poslovanju i budućim projektima.',
    },
    {
        image: 'https://resource.ewe.rs/media/HuaweiEvent2026/icon-mreze.png',
        heading: 'Rešenja za savremene mreže',
        text: 'Istražite tehnologije kreirane za potrebe modernih poslovnih mreža i različite scenarije primene.',
    },
    {
        image: 'https://resource.ewe.rs/media/HuaweiEvent2026/icon-eksperti.png',
        heading: 'Direktan kontakt sa ekspertima',
        text: 'Razgovarajte sa predstavnicima Huawei kancelarije i EWE kompanije i saznajte sve o proizvodima i mogućnostima saradnje.',
    },
];

const AGENDA_ITEMS = [
    {
        time: '11:00 - 11:30',
        title: 'Dobrodošlica & Networking',
        text: 'Okupljanje uz piće i neformalno druženje',
        filled: false,
    },
    {
        time: '11:30 - 11:40',
        title: 'Zvanično otvaranje događaja',
        text: 'Uvodna reč predstavnika EWE Comp-a',
        filled: false,
    },
    {
        time: '11:40 - 12:00',
        title: 'I Prezentacija - Channel Policy & Route 2026',
        text: 'Marija Đukić - Distribution Sales Manager',
        filled: true,
    },
    {
        time: '12:00 - 12:20',
        title: 'II Prezentacija - HUAWEI eKit SME Network Solutions & Products',
        text: 'Dejan Rotula - IP Solution Manager',
        filled: true,
    },
    {
        time: '12:20 - 12:40',
        title: 'Coffee Break & Networking',
        text: 'Osveženje, razmena iskustava i neformalno druženje',
        filled: false,
    },
    {
        time: '12:40 - 13:00',
        title: 'III Prezentacija - Huawei eKit Intelligent Office & Business Solutions',
        text: 'Nikola Risteski - Optical Solution Manager',
        filled: true,
    },
    {
        time: '13:00 - 13:20',
        title: 'IV Prezentacija - Huawei Enterprise SSDs solutions',
        text: 'Ilija Kocev - IT Solution Manager',
        filled: true,
    },
    {
        time: '13:20 - 13:30',
        title: 'Zatvaranje događaja',
        text: 'Završna reč predstavnika Ewe Comp-a',
        filled: false,
    },
    {
        time: '13:30 - 14:00',
        title: 'Ručak & Networking',
        text: '',
        filled: false,
    },
];

const HuaweiEventLanding = () => {
    return (
        <div className={styles['page']}>
            <div className={styles['hero']}>
                <img src="https://resource.ewe.rs/media/HuaweiEvent2026/HuaweiEvent2026-banner.png" alt="" className={styles['hero-image']} />
                <div className={styles['hero-content']}>
                    <div className={styles['logo-row']}>
                        <img src="https://resource.ewe.rs/media/HuaweiEvent2026/black_ewe_logo.png" alt="EWE logo" className={styles['logo-img']} />
                        <img src="https://resource.ewe.rs/media/HuaweiEvent2026/red_huawei_ekit_logo.png" alt="Huawei eKit logo" className={`${styles['logo-img']} ${styles['huawei-logo']}`}
                        />
                    </div>
                    <p className={styles['hero-eyebrow']}>Pozivamo vas na</p>
                    <h1 className={styles['hero-title']}>Huawei &amp; EWE Gold DP Technical Salon</h1>
                </div>
            </div>

            <div className={styles['intro-section']}>
                <p className={styles['greeting']}>Poštovani partneri,</p>
                <p className={styles['intro']}>
                    Kompanija EWE sa ponosom predstavlja <strong>Huawei eKit</strong>, novog partnera u svom distributerskom portfoliju.
                </p>
            </div>

            <div className={styles['info-band']}>
                <div className={styles['info-item']}>
                    <img src="https://resource.ewe.rs/media/HuaweiEvent2026/icon-datum.png" alt="" className={styles['info-icon']} />
                    <p className={styles['info-label']}>Datum:</p>
                    <p className={styles['info-value']}>23. septembar 2026.</p>
                </div>
                <div className={styles['info-item']}>
                    <img src="https://resource.ewe.rs/media/HuaweiEvent2026/icon-mesto.png" alt="" className={styles['info-icon']} />
                    <p className={styles['info-label']}>Mesto:</p>
                    <p className={styles['info-value']}>Srbolek, Sarajevska 84, Beograd</p>
                </div>
                <div className={styles['info-item']}>
                    <img src="https://resource.ewe.rs/media/HuaweiEvent2026/icon-broj-mesta.png" alt="" className={styles['info-icon']} />
                    <p className={styles['info-label']}>Broj mesta:</p>
                    <p className={styles['info-value']}>Ograničen</p>
                </div>
            </div>

            <div className={styles['agenda-section']}>
                <h2 className={styles['agenda-title']}>Agenda</h2>
                <div className={styles['agenda-timeline']}>
                    {AGENDA_ITEMS.map((item) => (
                        <div className={styles['agenda-item']} key={item.time}>
                            <span className={`${styles['agenda-dot']} ${item.filled ? styles['agenda-dot--filled'] : ''}`} />
                            <span className={styles['agenda-time']}>{item.time}</span>
                            <div className={styles['agenda-content']}>
                                <p className={styles['agenda-item-title']}>{item.title}</p>
                                {item.text && <p className={styles['agenda-text']}>{item.text}</p>}
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <div className={styles['why-band']}>
                {WHY_ITEMS.map((item) => (
                    <div className={styles['why-item']} key={item.heading}>
                        <img src={item.image} alt="" className={styles['why-icon']} />
                        <div className={styles['why-divider']} />
                        <div>
                            <p className={styles['why-heading']}>{item.heading}</p>
                            <p className={styles['why-text']}>{item.text}</p>
                        </div>
                    </div>
                ))}

                <p className={styles['deadline-note']}>
                    Pozivnica je ekskluzivna i broj mesta je ograničen, zato vas pozivamo da što pre potvrdite svoj dolazak. <strong>Prijava traje do 21.9.</strong>
                </p>
            </div>

            <div className={styles['cta-section']}>
                <div className={styles['cta-wrapper']}>
                    <Link to="/huawei-event-2026-prijava" className={styles['cta-button']}>
                        Prijavi se &nbsp;&gt;
                    </Link>
                </div>

                <p className={styles['closing-text']}>
                    Vidimo se na mestu gde se nova mrežna rešenja upoznaju izbliza, a nova saradnja dobija svoj prvi korak.
                </p>
            </div>
        </div>
    );
};

export default HuaweiEventLanding;
